module.exports = "/images/si.svg?220899b0829bdb7bec387163f9ad77e9";